const userStateMixin = {
    computed: {
        userState () {
            const user = this.$auth.user()
            if (!user) {
                return ''
            }

            const { primaryOrganization } = user
            return primaryOrganization
                ? primaryOrganization.mailingStateAbbreviation
                : ''
        },

        isUserInLA () {
            return this.userState === 'LA'
        },

        isUserInTX () {
            return this.userState === 'TX'
        }
    }
}

export default userStateMixin



// WEBPACK FOOTER //
// ./src/mixins/userState.js